export const definedTranslation = {
  events: {
    featured: {
      id: 'events-items-title',
      defaultMessage: 'Featured Events',
    },
    upcoming: {
      id: 'events-upcoming-title',
      defaultMessage: 'Upcoming events',
    },
  },
};
